import React from 'react'
import { Link } from "react-router-dom"
import '../button/button.css'

export default function Button({ asLink, to, color, height, onClick, title, width, ...otherProps }) {
  return (
    <div {...otherProps}>
      {
        asLink ? (
          <Link
            to={to}
            onClick={onClick}
            className="form-button-container"
            style={{ backgroundColor: color, height: height, width: width }}
          >{title}</Link>
        ) : (
          <button
            onClick={onClick}
            className="form-button-container"
            style={{ backgroundColor: color, height: height, width: width }}
          >{title}</button>
        )
      }
    </div>
  )
}


